import t from"./postIFrameMessage.js";const a=async e=>{t({action:"event",data:e})};var n=a;export{n as default};
